module.exports = __webpack_public_path__ + "img/alarm-clock-minus.201a6153.svg";